export default __webpack_public_path__ + "static/media/icon_header_hope_28_Filled.db50b38d.svg";